import React from 'react';
import { Box } from '@mui/material';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';
import PersonCard from '../../../shared/Cards/PersonCard';
import Section from '../../../shared/Section/Section';

function Teachers({ theme, title, subtitle, bg, teachers, swiperProps = {} }) {
  return (
    <Section
      theme={theme}
      title={title}
      subtitle={subtitle}
      bg={bg}
      withoutBg={!bg}
    >
      {!!teachers.length && (
        <SwiperComponent
          slidesPerView={1.36}
          spaceBetween={14}
          breakpoints={{
            500: {
              slidesPerView: 1.6,
              spaceBetween: 18,
            },
            700: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            850: {
              slidesPerView: 2.6,
              spaceBetween: 24,
            },
            1010: {
              slidesPerView: teachers.length <= 3 ? 3 : 3.45,
              spaceBetween: teachers.length <= 3 ? 56 : 24,
            },
            1440: {
              slidesPerView: teachers.length <= 3 ? 3.35 : 4,
              spaceBetween: teachers.length <= 3 ? 56 : 24,
            },
            1536: {
              slidesPerView: teachers.length <= 3 ? 3.45 : 4,
              spaceBetween: teachers.length <= 3 ? 56 : 24,
            },
            ...swiperProps?.breakpoints,
          }}
          centeredSlides={false}
          {...swiperProps}
          slides={teachers.map(
            (teacher) =>
              function () {
                return (
                  <Box sx={{ height: '100%' }} key={teacher.photo}>
                    <PersonCard {...teacher} height="100%" />
                  </Box>
                );
              },
          )}
        />
      )}
    </Section>
  );
}

export default Teachers;
